module.exports = __webpack_public_path__ + "static/img/4.b77a02a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/99/zh/4.png
// module id = jMF+
// module chunks = 0